import { type Meta } from '../types/docs';

const META: Meta = {
  description: 'A set chip was loaded in the picker',
  name: 'size_set_applied',
  params: [
    {
      description: 'Where the set was applied from',
      name: 'source',
      required: true,
      type: 'enum',
      values: ['canvas_picker'],
    },
    {
      description: 'The id of the size set',
      name: 'size_set_id',
      required: true,
      type: 'string',
    },
    {
      description: 'Number of members in the set',
      name: 'member_count',
      required: true,
      type: 'number',
    },
  ],
};

export default META;
